import {AnyAction, Reducer} from "redux";
import {IViewPort} from "../types";
import {fromJS} from "immutable";
import {ACTION_TYPES} from "../actions";
import {initViewport} from "../../utils/initViewport";

const initialState: IViewPort = fromJS(initViewport);

const reducer: Reducer<IViewPort> = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.SET_VIEWPORT:
            return setViewport(state, action);
        default: {
            return state
        }
    }
};

function setViewport (state: IViewPort, action: AnyAction) {
    return {...state, ...action.payload};
}

export { reducer as ViewportReducer };
